import React, { useContext, useState } from 'react';
import { PrivateRouteProps } from './types';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Dashboard } from '../../Pages/Dashboard/Dashboard';
import UserSection from '../../Components/Sections/UsersSection';

export const PrivateRoutes = () => {
    return (
        <Routes>
            <Route path="/dashboard/*" element={<Dashboard />} />               
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
};

